<template>
    <v-menu content-class="nx-show-more">
    <template #activator="{on}">
        <v-btn
          v-show="!hidden"
          :class="buttonClassname"
          :large="large"
          :small="small"
          icon
          v-on="on"
          @click.native.stop.prevent
        >
          <v-icon :color="color">more_vert</v-icon>
      </v-btn>
    </template>
    <slot />
  </v-menu>
</template>

<script>
export default {
  name: 'NxShowMore',
  props: {
    color: {
      type: String,
      default: () => 'primary',
    },
    large: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    buttonClassname: {
      type: String,
    },
    hidden: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus">
.nx-show-more .v-list--dense .v-list__tile {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
</style>
